// Central config for project-wide constants
export const PROJECT_NAME = "Toollyzer";
